import get from 'lodash/get';

export default ({source, record = {}}) => get(record, source) || '-';
